/**
 * Anfahrhilfe aus Sicht dieses Apartments: geerbte Schritte des Objekts, hier ueberschriebene
 * und eigene. Gepflegt wird die gemeinsame Fassung am Objekt — hier steht nur, was von der
 * Regel abweicht.
 */
import { Route } from 'lucide-react';
import { ArrivalGuideEditor } from '../arrival-guide';
import { PropertyFormSectionHeader } from '../property-form/ChannelsPushedSection';
import { useApartmentDetail } from './ApartmentDetailLayout';

export function ApartmentArrivalCard() {
  const { propertyId, readOnly } = useApartmentDetail();
  // Kein eigener Kartenrahmen: der Editor bringt Schrittliste und Handy-Vorschau als eigene Flächen
  // mit, eine Karte darum wäre Karte in Karte.
  return (
    <section className="space-y-4">
      <PropertyFormSectionHeader
        icon={<Route size={13} strokeWidth={2} />}
        iconTint="sage"
        title="Anfahrhilfe"
        subtitle="Nur im Gastportal sichtbar. Felder werden erst beim Ausliefern eingesetzt."
      />
      <ArrivalGuideEditor scope={{ kind: 'apartment', id: propertyId }} canEdit={!readOnly} />
    </section>
  );
}
